import styled, {css} from 'styled-components';
import {primary, neutral, white} from '../../../../style/colors';

const center = css`
  display: flex;
  align-items: center;
`;
const scrollbar = css`
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: ${neutral[300]};
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: ${neutral[400]};
  }
`;

export const SidebarContainer = styled.div`
  padding: 20px 16px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: linear-gradient(to bottom, ${neutral[50]}, ${neutral[100]});
  ${scrollbar}
`;

export const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid ${neutral[200]};
  flex-shrink: 0;
`;

export const FilterTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: ${neutral[900]};
  margin: 0;
  ${center};
  gap: 10px;
  i {
    font-size: 22px;
    color: ${neutral[500]};
  }
`;

export const SectionContainer = styled.div`
  background-color: ${white};
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid ${neutral[200]};
  transition: all 0.2s;
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: ${neutral[300]};
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 4px 0;
  font-weight: 700;
  font-size: 14px;
  color: ${neutral[900]};
  user-select: none;
  &:hover {
    color: ${neutral[700]};
  }
  i {
    font-size: 20px;
    color: ${neutral[500]};
    transition: transform 0.3s ease;
    transform: ${(p) => (p.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;

export const SectionContent = styled.div`
  padding-top: ${(p) => (p.isOpen ? '12px' : '0')};
  max-height: ${(p) => (p.isOpen ? '400px' : '0')};
  overflow-y: auto;
  overflow-x: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: ${neutral[300]};
    border-radius: 2px;
  }
`;

export const CheckboxContainer = styled.label`
  ${center};
  padding: 8px 0;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s;
  &:hover {
    color: ${neutral[700]};
  }
`;

export const CheckboxInput = styled.input`
  width: 18px;
  height: 18px;
  margin-right: 10px;
  cursor: pointer;
  accent-color: ${primary[500]};
  border-radius: 4px;
`;

export const CheckboxLabel = styled.span`
  font-size: 13px;
  transition: all 0.15s;
  color: ${(p) => (p.checked ? neutral[800] : neutral[600])};
  font-weight: ${(p) => (p.checked ? '600' : '400')};
`;

export const RadioContainer = styled.label`
  ${center};
  padding: 12px 14px;
  margin-bottom: 8px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
  border-radius: 10px;
  border: 1px solid ${neutral[200]};
  border-left: ${(p) => (p.checked ? `3px solid ${primary[500]}` : `1px solid ${neutral[200]}`)};
  background: ${(p) => (p.checked ? neutral[50] : white)};
  &:hover {
    background: ${neutral[50]};
    border-color: ${neutral[300]};
    border-left-color: ${(p) => (p.checked ? primary[500] : neutral[300])};
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

export const RadioInput = styled.input`
  width: 18px;
  height: 18px;
  margin-right: 12px;
  cursor: pointer;
  accent-color: ${primary[500]};
  &:focus {
    outline: none;
  }
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 2px solid ${neutral[300]};
  border-radius: 50%;
  position: relative;
  transition: all 0.2s;
  &:checked {
    border-color: ${primary[500]};
    background-color: ${white};
  }
  &:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${primary[500]};
  }
  &:hover {
    border-color: ${primary[500]};
  }
`;

export const RadioLabel = styled.div`
  ${center};
  gap: 8px;
  font-size: 14px;
  transition: all 0.2s;
  color: ${(p) => (p.checked ? neutral[800] : neutral[600])};
  font-weight: ${(p) => (p.checked ? '600' : '500')};
  i {
    font-size: 18px;
    color: ${(p) => (p.checked ? primary[500] : neutral[400])};
  }
`;
